import Container from '@mui/material/Container';
import Button from "@mui/material/Button";
import LayoutPage from "../../../templates/Layout/LayoutPage";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  const insightsPage = () => {
    navigate("/insights");
  };

  const errorStyles = {
    textAlign: 'center',
    '& h2': {
      fontSize: {
        xs: '4rem',
        lg: '5rem'
      },
      marginBottom: 0,
    },
    '& p': {
      fontSize: '1.5rem',
      marginTop: 0,
    }
  }

  return (
    <LayoutPage
      pageTitle="Page Not Found"
      description="Build custom groups based on filters"
      type="dashboard"
    >
      <Container maxWidth="md" sx={errorStyles}>
        <h2>404 Error</h2>
        <p>We can't find the page that you're looking for</p>
        <Button
            variant="contained"
            onClick={insightsPage}
        >
          Home
        </Button>
      </Container>
    </LayoutPage>
  );
};

export default PageNotFound;
